import styles from './style.postcss';

import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import is from 'is_js';
import { Grid, connect, NumberInput, Icon, Button } from 'omni-common-ui';
import { actions as academicActions } from 'data/AcademicInfo';
import {
  TableView,
  TableViewTr,
  HeaderTd,
  MemberCardTd,
  ProgressCardTd,
  TextTd,
  NormalTd,
} from 'components/TableView';
import ExpansionButton from 'components/ExpansionButton';

const ASCENDING = 'Ascending';
const DESCENDING = 'Descending';
const skillScoresHeaders = [
  { key: 'listening', text: 'Listening' },
  { key: 'grammar', text: 'Grammar' },
  { key: 'reading', text: 'Reading' },
  { key: 'vocabulary', text: 'Vocabulary' },
  { key: 'writing', text: 'Writing' },
  { key: 'speaking', text: 'Speaking' },
  { key: 'phonics', text: 'Phonics' },
];
const NUMBER_OF_DEFAULT_STUDENTS = 3;

class Concerns extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      queryParams: {},
      scoreFrom: 0,
      scoreTo: 69,
      isExpand: false,
    };
    this._renderTableRow = this._renderTableRow.bind(this);
    this._onFilterChange = this._onFilterChange.bind(this);
    this._onScoreFromChange = this._onScoreFromChange.bind(this);
    this._onScoreToChange = this._onScoreToChange.bind(this);
    this._onFilterApply = this._onFilterApply.bind(this);
    this._sortStudents = this._sortStudents.bind(this);
  }

  componentDidMount() {
    this._fetchStudentSkills();
  }

  _fetchStudentSkills() {
    const { scoreFrom, scoreTo } = this.state;
    if ((is.not.number(scoreFrom) || is.not.number(scoreTo))) return;
    if (scoreFrom > scoreTo) return;
    this.props.fetchAcademicInfoConcernsStudentSkills(scoreFrom, scoreTo);
  }

  _onScoreFromChange(value) {
    this.setState({ scoreFrom: value });
  }

  _onScoreToChange(value) {
    this.setState({ scoreTo: value });
  }

  _onFilterApply() {
    this._fetchStudentSkills();
  }

  _renderScoresFilter(headersCount) {
    const { scoreFrom, scoreTo } = this.state;
    return <TableViewTr>
      <NormalTd colSpan={headersCount} className={styles.Concerns_filters}>
        <span>Scores(%) from</span>
        <NumberInput className={styles.Concerns_filters_input}
            value={scoreFrom}
            min="0"
            max="100"
            onChange={this._onScoreFromChange} />
        <span>to</span>
        <NumberInput className={styles.Concerns_filters_input}
            value={scoreTo}
            min="0"
            max="100"
            onChange={this._onScoreToChange} />
        <Button type={Button.Type.primary}
            onClick={this._onFilterApply}
            className={styles.Concerns_filters_button}>
          <Icon id="cycle" />
        </Button>
      </NormalTd>
    </TableViewTr>;
  }

  _onSort(sortKey) {
    let sortType = ASCENDING;
    if (sortKey === this.state.sortKey) {
      sortType = this.state.sortType === ASCENDING ? DESCENDING : ASCENDING;
    }
    this.setState({ sortKey, sortType });
  }

  _renderTableHeaderRow() {
    const { sortKey, sortType } = this.state;
    const headers = [
      { key: 'name', text: 'Name' },
      { key: 'groupCode', text: 'Group Code' },
      ...skillScoresHeaders,
      { key: 'recentUnit', text: 'Latest Unit' },
    ];
    const columnHeaders = <TableViewTr>
      {
        headers.map((header) => <HeaderTd sortable
            sortType={sortKey === header.key ? sortType : ''}
            onSort={() => this._onSort(header.key)}
            key={header.key}>
          {header.text}
        </HeaderTd>)
      }
    </TableViewTr>;
    const headersCount = React.Children.count(columnHeaders.props.children);

    return [this._renderScoresFilter(headersCount), columnHeaders];
  }

  _renderSkillScores(row) {
    return skillScoresHeaders.map((skillScoresHeader) => {
      const filteredSkillScore = row.skillScores.find((skillScore) =>
        skillScore.name.toLowerCase().trim() === skillScoresHeader.key.toLowerCase());
      if (! filteredSkillScore || is.not.existy(filteredSkillScore.score)) {
        return <ProgressCardTd percent={null} />;
      }
      const key = `${filteredSkillScore.skillId}-${row.groupId}-${row.studentGeneralInfo}`;
      return <ProgressCardTd key={key} percent={filteredSkillScore.score} />;
    });
  }

  _renderTableRow(row) {
    const { firstName, lastName, localName, avatarUrl, gender } = row.studentGeneralInfo;
    const groupLink = this.props.buildRoute(`/group/${row.groupId}`);
    return <TableViewTr>
      <MemberCardTd name={`${firstName} ${lastName}`}
          surname={localName}
          avatarUrl={avatarUrl}
          gender={gender} />
      <NormalTd>
        <Link to={groupLink}>{row.groupCode}</Link>
      </NormalTd>
      {this._renderSkillScores(row)}
      <TextTd text={row.recentUnit} />
    </TableViewTr>;
  }

  _onFilterChange(queryParams) {
    this.setState({ queryParams });
  }

  _renderExpansionButton() {
    const { concernsStudentSkills } = this.props;
    if (concernsStudentSkills.size <= NUMBER_OF_DEFAULT_STUDENTS) return;
    const { isExpand } = this.state;
    return <ExpansionButton className={styles.Concerns_expansionButton}
        isExpand={isExpand}
        onExpansionButtonClick={() => this.setState({ isExpand: ! isExpand })} />;
  }

  _sortStudents(currentObject, nextObject) {
    let current = currentObject.get(this.state.sortKey);
    let next = nextObject.get(this.state.sortKey);
    if (this.state.sortKey === 'name') {
      current = `${currentObject.studentGeneralInfo.firstName} ${currentObject.studentGeneralInfo.lastName}`.toLowerCase();
      next = `${nextObject.studentGeneralInfo.firstName} ${nextObject.studentGeneralInfo.lastName}`.toLowerCase();
    } else if (skillScoresHeaders.map((skillScoresHeader) => skillScoresHeader.key.toLowerCase())
        .indexOf(this.state.sortKey.toLowerCase()) >= 0) {
      const currentScoreDescriptor = currentObject.skillScores.find((skillScore) =>
        `${skillScore.get('name').toLowerCase()}` === this.state.sortKey.toLowerCase());
      const nextScoreDescriptor = nextObject.skillScores.find((skillScore) =>
        `${skillScore.get('name').toLowerCase()}` === this.state.sortKey.toLowerCase());
      current = currentScoreDescriptor && currentScoreDescriptor.get('score');
      next = nextScoreDescriptor && nextScoreDescriptor.get('score');
      current = is.number(current) ? current : null;
      next = is.number(next) ? next : null;
    }
    // Make sure none score student sorted bottom.
    if (this.state.sortType === 'Ascending') {
      current = current === null ? 101 : current;
      next = next === null ? 101 : next;
    } else if (this.state.sortType === 'Descending') {
      current = current === null ? - 101 : current;
      next = next === null ? - 101 : next;
    }
    if (current > next) {
      return this.state.sortType === 'Ascending' ? 1 : - 1;
    } else if (current < next) {
      return this.state.sortType === 'Ascending' ? - 1 : 1;
    }
    return 0;
  }

  _collapseRowsIfNeeded(rows) {
    if (this.state.isExpand) return rows;
    return rows.slice(0, NUMBER_OF_DEFAULT_STUDENTS);
  }

  _renderStudentSkills() {
    let { concernsStudentSkills } = this.props;
    const numberOfStudents = concernsStudentSkills.size;
    if (numberOfStudents > 0 && is.not.undefined(this.state.sortKey)) {
      concernsStudentSkills = concernsStudentSkills.sort(this._sortStudents);
    }
    concernsStudentSkills = this._collapseRowsIfNeeded(concernsStudentSkills);
    concernsStudentSkills = concernsStudentSkills.toJS();
    return <TableView source={concernsStudentSkills}
        tableTitle={`Students with low skill scores (${numberOfStudents})`}
        renderTableRow={this._renderTableRow}
        noResultsString="There are no scores within this range."
        query={this.state.queryParams}
        onFilterChange={this._onFilterChange}
        customerFooter={this._renderExpansionButton()}
        customerHeader={this._renderTableHeaderRow()} />;
  }

  render() {
    return <Grid outerMargin>
      <Grid.Group>
        {this._renderStudentSkills()}
      </Grid.Group>
    </Grid>;
  }
}

Concerns.propTypes = {
  fetchAcademicInfoConcernsStudentSkills: PropTypes.func.isRequired,
  concernsStudentSkills: PropTypes.shape(),
  buildRoute: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const concernsStudentSkills = state.get('rootReducer').get('academicInfoConcernsStudentSkills');
  return { concernsStudentSkills };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(academicActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Concerns);



// WEBPACK FOOTER //
// ./containers/UserDashboard/AcademicInfo/Concerns/component.jsx